<lovers-popup
  [exibir]="exibirPopupLogout"
  (onClose)="exibirPopupLogout = false"
  tamanho="pequeno"
  *ngIf="membro !== undefined"
>
  <div class="popup__header">
    <p class="header__title">Já vai, {{ this.membro?.descricaoNivel }}?</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <h6 class="mb-0">Volta logo, estamos empolgados para te ver de novo.</h6>
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center mt-4">
      <button class="lovers-button" (click)="desconectar()" style="width: 50%">
        Sair
      </button>
    </div>
  </div>
</lovers-popup>

<header
  class="lovers__header"
  *ngIf="exibirHeader"
  [ngClass]="{
    'headers--deslogado': !membro,
    emValidaDados: estaEmValidarDados
  }"
>
  <div [ngClass]="{ emValidaDados: estaEmValidarDados }">
    <img
      *ngIf="!voltarButton"
      class="header__lovers__logo"
      src="assets/images/logos/cacaulovers.png"
      (click)="irParaHome()"
      [ngClass]="{ 'logo--logado': true }"
    />
    <button
      id="entrar"
      (click)="irParaLogin()"
      class="button__entrar"
      *ngIf="!membro && width <= 480 && !estaEmValidarDados"
    >
      Entrar
    </button>
    <a
      *ngIf="!membro && width <= 480"
      href="https://www.cacaushow.com.br/"
      target="_blank"
    >
      <img src="assets/images/logos/cs.png" class="sign__logo" />
    </a>
    <button class="voltar" (click)="voltarPagAnterior()" *ngIf="voltarButton">
      <img src="assets/images/icons/voltar_app.svg" alt="Ícone de voltar" />
    </button>
  </div>

  <div>
    <div class="menu__logado" *ngIf="membro && menus.length > 0">
      <div
        class="menu__item"
        *ngFor="let menuItem of menus"
        (click)="navegarPara(menuItem)"
      >
        <p
          *ngIf="menuItem.icone == ''"
          class="item__nome"
          [ngClass]="{ 'item--selecionado': menuItem.link === paginaAtual }"
        >
          {{ menuItem.nome }}
        </p>

        <p
          *ngIf="menuItem.icone != ''"
          [ngClass]="{ 'item--selecionado': menuItem.link === paginaAtual }"
        >
          <img
            class="item__icone"
            [src]="menuItem.icone"
            (mouseover)="menuItem.icone = menuItem.iconeHover"
            (mouseout)="menuItem.icone = menuItem.iconeOut"
          />
        </p>

        <div
          [ngClass]="{ item__atual: menuItem.icone == '' }"
          *ngIf="menuItem.link === paginaAtual"
        ></div>
      </div>
    </div>
  </div>

  <div>
    <button
      id="entrar"
      (click)="irParaLogin()"
      class="button__entrar__desktop"
      *ngIf="!membro && width >= 1200 && !estaEmValidarDados"
    >
      Entrar
    </button>
    <button
      id="cadastro"
      (click)="irParaCadastro()"
      class="button__cadastro__desktop"
      *ngIf="!membro && width >= 1200 && !estaEmValidarDados"
    >
      Faça já o seu cadastro!
    </button>
    <img
      [hidden]="membro"
      class="header__cs__logo"
      src="assets/images/logos/cacau_show_isotipo.png"
      (click)="irParaEcommerce()"
    />

    <div
      class="subheader__pontuacao"
      [ngClass]="{ hide: !exibirPontuacaoSaldo || urlAtual == '/index' }"
      *ngIf="logado && membro !== undefined"
      id="card--top--desktop"
    >
      <lovers-pontos
        [pontuacao]="membro.saldo.saldoPontos"
        [redirectExtrato]="true"
        [minimo]="true"
        [exibirVoceTem]="false"
      ></lovers-pontos>
    </div>

    <div
      *ngIf="logado && membro !== undefined"
      style="cursor: pointer"
      (click)="voucherModal.openVoucher()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M26.0015 16.6667C26.0015 14.8267 27.4948 13.3334 29.3348 13.3334V12C29.3348 6.66671 28.0015 5.33337 22.6681 5.33337H9.33468C4.00131 5.33337 2.66797 6.66671 2.66797 12V12.6667C4.50798 12.6667 6.00132 14.16 6.00132 16C6.00132 17.84 4.50798 19.3334 2.66797 19.3334V20C2.66797 25.3334 4.00131 26.6667 9.33468 26.6667H22.6681C28.0015 26.6667 29.3348 25.3334 29.3348 20C27.4948 20 26.0015 18.5067 26.0015 16.6667Z"
          stroke="white"
          stroke-width="2.3851"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.332 5.33337V26.6667"
          stroke="white"
          stroke-width="2.3851"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="7.03 7.03"
        />
      </svg>
    </div>

    <div class="container__notificacao" (click)="irParaNotificacoes()">
      <p class="info__notificacao" *ngIf="logado && membro !== undefined">
        <img
          class="notificacao__sino"
          id="sino"
          #sino
          src="assets/images/icons/sino.png"
        />
      </p>
    </div>

    <div class="usuario" *ngIf="membro" (click)="exibirUsuarioDropdown()">
      <div
        class="usuario__info"
        [ngClass]="{ 'cor--perfil': exibirDropdownUsuario }"
      >
        <div class="info__saudacao" id="info__user">
          <p class="info__foto" *ngIf="membro !== undefined">
            <img
              class="icone__foto"
              src="assets/images/icons/user.png"
              alt=""
            />
          </p>
          <p>Oi,</p>
          <p *ngIf="membro !== undefined">
            {{
              membro.nomeSocial !== null
                ? membro.nomeSocial.split(" ")[0]
                : membro.nome.split(" ")[0]
            }}
          </p>
          <img
            class="info__icone"
            [ngClass]="{ 'icon--invert': exibirDropdownUsuario }"
            src="assets/images/icons/seta_baixo.png"
          />
        </div>

        <div [ngClass]="{ 'usuario--container': exibirDropdownUsuario }"></div>
      </div>

      <div
        class="usuario__dropdown"
        [ngClass]="{ 'dropdown--aberto': exibirDropdownUsuario }"
      >
        <div
          class="dropdown__cashback"
          *ngIf="membro !== undefined && membro?.saldo?.saldoCashback > 10"
        >
          <p>Você possui cashback!</p>
          <p>
            {{ membro.saldo.saldoCashback | moeda }}
          </p>
        </div>
        <div class="opcoes__menu">
          <p class="id__lovers">Código Lovers {{ codeIdLovers() }}</p>
          <div class="opcao" (click)="irParaMinhasExperiencias()">
            <svg
              class="opcao__icone"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.6328 4.4003L12.5848 3.83201C12.1883 4.51883 11.3091 4.75442 10.6222 4.35789C9.93544 3.96135 9.69985 3.08211 10.0964 2.39529L9.84753 2.25162C7.85679 1.10224 7.07176 1.31259 5.92241 3.30337L3.04902 8.28031C1.89967 10.2711 2.43304 10.9842 3.04902 11.6002"
                stroke="#F5BDB2"
                stroke-width="1.23389"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.45618 5.19647L8.12891 6.62555"
                stroke="#F5BDB2"
                stroke-width="1.23389"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="3.02 7.5"
              />
              <path
                d="M7.26115 14.3387C7.6952 15.0025 7.50878 15.8934 6.84504 16.3275L7.15957 16.8085C8.41767 18.7324 9.21316 18.8988 11.137 17.6407L15.9467 14.4953C17.8706 13.2372 18.037 12.4417 16.7789 10.5178L16.6217 10.2773C15.9579 10.7114 15.067 10.5249 14.6329 9.86121C14.1989 9.19747 14.3853 8.30651 15.0491 7.87245L14.8918 7.63196C13.6337 5.70808 12.8382 5.54165 10.9143 6.79978L6.10464 9.94512C4.18077 11.2033 4.01432 11.9988 5.27242 13.9226C5.93616 13.4886 6.82711 13.675 7.26115 14.3387Z"
                stroke="#F5BDB2"
                stroke-width="1.23389"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.5078 15.4388L9.47542 7.74325"
                stroke="#F5BDB2"
                stroke-width="1.23389"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="3.02 3.02"
              />
            </svg>
            <p>Meus resgates</p>
          </div>
          <div class="opcao" (click)="irParaMeusDados()">
            <img class="opcao__icone" src="assets/images/icons/pessoa.png" />
            <p>Meus dados</p>
          </div>
          <div class="opcao" (click)="irParaExtrato()">
            <img class="opcao__icone" src="assets/images/icons/extrato.png" />
            <p>Extrato</p>
          </div>
          <!-- <div class="opcao" (click)="irParaPalito()">
            <svg class="opcao__icone" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.09366 0.80334C6.61313 0.835096 6.49243 0.845218 6.35319 0.865447C5.50449 0.988766 4.70439 1.43252 4.13082 2.09806C3.65566 2.64942 3.35635 3.30948 3.25267 4.03456C3.18407 4.5144 3.18083 6.98813 3.24683 8.49391C3.27744 9.19253 3.30868 9.66536 3.33248 9.79064C3.45141 10.4168 3.95608 10.9312 4.58184 11.0642C4.68428 11.0859 5.38198 11.1477 5.53119 11.1481C5.64674 11.1485 5.64453 11.1406 5.60994 11.4296C5.55963 11.8499 5.48925 12.5713 5.47028 12.8613C5.4448 13.2508 5.47765 13.5615 5.57463 13.8482C5.62556 13.9987 5.76267 14.2633 5.85049 14.3806C6.15758 14.7904 6.61937 15.068 7.16319 15.1695C7.37949 15.2099 7.82756 15.2099 8.04387 15.1695C8.72186 15.0429 9.24178 14.6646 9.53102 14.0874C9.70527 13.7396 9.76928 13.3581 9.73676 12.8613C9.7181 12.5762 9.64792 11.8546 9.59719 11.4262C9.57396 11.2299 9.57135 11.1693 9.58575 11.1602C9.59599 11.1537 9.63655 11.1483 9.67587 11.1481C9.82507 11.1477 10.5228 11.0859 10.6252 11.0642C11.2507 10.9313 11.7557 10.4168 11.8745 9.79129C11.8996 9.65872 11.9468 8.85657 11.9789 8.01557C11.9896 7.7375 11.9984 6.97444 11.9987 6.30281L11.9992 5.09154L11.9581 5.00392C11.8819 4.84167 11.7357 4.71764 11.5681 4.6731C11.4559 4.64326 11.3858 4.647 11.219 4.69178C11.018 4.74574 10.7212 4.75897 10.539 4.7221C10.0212 4.61732 9.63188 4.26163 9.46563 3.74139C9.40884 3.56365 9.39519 3.28467 9.43393 3.09332C9.50764 2.72918 9.65822 2.50127 10.0488 2.16279C10.2774 1.96461 10.3229 1.67609 10.1662 1.41785C10.1024 1.3128 10.0288 1.25344 9.86057 1.17137C9.46427 0.978088 9.03373 0.870215 8.47649 0.824619C8.27697 0.808294 7.25632 0.792586 7.09366 0.80334ZM7.08593 1.96678C6.77602 1.9842 6.52223 2.0104 6.39066 2.03853C6.07893 2.10521 5.7163 2.264 5.46237 2.44504C5.26712 2.58426 4.9622 2.89567 4.83514 3.08565C4.62719 3.39655 4.48002 3.75926 4.41929 4.11046C4.32661 4.6465 4.33988 7.29671 4.44455 9.1534C4.47089 9.62064 4.48583 9.68292 4.59853 9.79547C4.71073 9.90752 4.77502 9.92872 5.07637 9.95309C6.69587 10.084 8.51119 10.084 10.1307 9.95309C10.432 9.92872 10.4963 9.90752 10.6085 9.79547C10.7287 9.67548 10.736 9.6382 10.7706 8.97515C10.8137 8.14836 10.8318 7.57956 10.8432 6.69486L10.8531 5.92193L10.779 5.91178C10.7382 5.90619 10.6692 5.9015 10.6258 5.90136C10.4496 5.90076 10.1263 5.82955 9.88776 5.73876C9.12816 5.4497 8.51945 4.76556 8.32345 3.98056C8.26498 3.74642 8.24864 3.57159 8.25712 3.27076C8.26932 2.83716 8.34129 2.55181 8.53076 2.18589C8.58813 2.07507 8.61444 2.0092 8.60287 2.00537C8.50179 1.97195 7.46384 1.94555 7.08593 1.96678ZM6.79453 11.3022C6.78948 11.3489 6.76461 11.5685 6.73924 11.7902C6.63206 12.7268 6.60542 13.1714 6.64507 13.3622C6.6973 13.6136 6.86238 13.8298 7.0808 13.9328C7.26176 14.0182 7.36647 14.0396 7.60353 14.0396C7.84059 14.0396 7.94529 14.0182 8.12625 13.9328C8.34468 13.8298 8.50975 13.6136 8.56199 13.3622C8.60163 13.1714 8.575 12.7268 8.46782 11.7902C8.44245 11.5685 8.41757 11.3489 8.41252 11.3022L8.40336 11.2174H7.60353H6.8037L6.79453 11.3022Z" fill="#F5BDB2"/>
            </svg>              
            <p>Palito Premiado</p>
          </div> -->
          <div class="opcao" (click)="irParaCausa()">
            <img class="opcao__icone" src="assets/images/icons/causa.png" />
            <p>Lovers pela causa</p>
          </div>
          <div class="opcao" (click)="irParaIndicacoes()">
            <img
              class="opcao__icone"
              src="assets/images/icons/pessoa-add.png"
            />
            <p>Indicações</p>
          </div>
          <div class="opcao" (click)="irParaAjuda()">
            <img class="opcao__icone" src="assets/images/icons/ajuda.png" />
            <p>Ajuda</p>
          </div>
          <div class="opcao" (click)="exibirModalLogout(true)">
            <img class="opcao__icone" src="assets/images/icons/sair.png" />
            <p>Sair</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="header__hamburguer" *ngIf="membro">
    <div (click)="voucherModal.openVoucher()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M26.0015 16.6667C26.0015 14.8267 27.4948 13.3334 29.3348 13.3334V12C29.3348 6.66671 28.0015 5.33337 22.6681 5.33337H9.33468C4.00131 5.33337 2.66797 6.66671 2.66797 12V12.6667C4.50798 12.6667 6.00132 14.16 6.00132 16C6.00132 17.84 4.50798 19.3334 2.66797 19.3334V20C2.66797 25.3334 4.00131 26.6667 9.33468 26.6667H22.6681C28.0015 26.6667 29.3348 25.3334 29.3348 20C27.4948 20 26.0015 18.5067 26.0015 16.6667Z"
          stroke="white"
          stroke-width="2.3851"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.332 5.33337V26.6667"
          stroke="white"
          stroke-width="2.3851"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="7.03 7.03"
        />
      </svg>
    </div>

    <div
      *ngIf="logado && membro !== undefined"
      id="card--top--mobile"
      [ngClass]="{ hide: !exibirPontuacaoSaldo || urlAtual == '/index' }"
    >
      <lovers-pontos
        [pontuacao]="membro.saldo.saldoPontos"
        [redirectExtrato]="true"
        [minimo]="true"
        [exibirVoceTem]="false"
      ></lovers-pontos>
    </div>
    <app-hamburguer (onChange)="menuMobileAberto = $event"></app-hamburguer>
  </div>
</header>

<div class="header__background" *ngIf="exibirHeader">
  <img
    class="background__imagem__header"
    src="assets/images/backgrounds/background_header.png"
    [ngClass]="{ ocultarSeEmValidarDados: estaEmValidarDados }"
  />
</div>

<div
  class="menu__mobile"
  *ngIf="membro"
  [ngClass]="{ 'menu--aberto': menuMobileAberto }"
>
  <div class="menu__fechar" (click)="menuMobileAberto = false">
    <img class="fechar__icone" src="assets/images/icons/x.png" />
  </div>

  <div class="menu__perfil">
    <div class="perfil__imagem">
      <p class="imagem__texto" *ngIf="membro !== undefined">
        {{ membro.nomeSocial !== null ? membro.nomeSocial[0] : membro.nome[0] }}
      </p>
    </div>
    <div class="perfil__usuario">
      <p *ngIf="membro !== undefined">
        Oi,
        {{
          membro.nomeSocial !== null
            ? membro.nomeSocial.split(" ")[0]
            : membro.nome.split(" ")[0]
        }}
      </p>
      <span class="id__lovers"> Código Lovers {{ codeIdLovers() }} </span>
    </div>
  </div>

  <div
    class="menu__cashback"
    *ngIf="membro !== undefined && membro?.saldo?.saldoCashback > 10"
  >
    <p class="cashback__descricao">Você possui cashback!</p>
    <p class="cashback__valor">
      {{ membro.saldo.saldoCashback | moeda }}
    </p>
  </div>

  <div class="menu__navegacao" *ngIf="menus.length > 0">
    <!-- <div
      class="menu__item item--auto"
      *ngFor="let menuItem of menus"
      (click)="navegarPara(menuItem)"
    >
      <p class="item__nome">{{ menuItem.nome }}</p>
    </div> -->
    <!-- <div class="navegacao__separador"></div> -->
    <div class="menu__item" (click)="irParaHome()">
      <img class="item__icone" src="assets/images/icons/casa.png" />
      <p class="item__nome">Início</p>
    </div>
    <div class="menu__item" (click)="irParaMinhasExperiencias()">
      <img
        class="item__icone ajuste__icone"
        src="assets/images/icons/meus_resgates.svg"
      />
      <p class="item__nome">Meus resgates</p>
    </div>
    <div id="meusDados" class="menu__item" (click)="irParaMeusDados()">
      <img
        class="item__icone ajuste__icone"
        src="assets/images/icons/pencil.png"
      />
      <p class="item__nome">Meus dados</p>
    </div>
    <div class="menu__item" (click)="irParaPalito()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6405 1.20452C9.91969 1.25216 9.73864 1.26734 9.52978 1.29768C8.25673 1.48266 7.05659 2.1483 6.19623 3.14661C5.48348 3.97364 5.03452 4.96373 4.87901 6.05135C4.77611 6.77111 4.77124 10.4817 4.87025 12.7404C4.91616 13.7883 4.96302 14.4976 4.99871 14.6855C5.17712 15.6247 5.93412 16.3964 6.87276 16.5958C7.02642 16.6284 8.07297 16.721 8.29678 16.7217C8.47011 16.7223 8.4668 16.7105 8.41491 17.1439C8.33945 17.7743 8.23388 18.8565 8.20542 19.2915C8.1672 19.8758 8.21648 20.3417 8.36195 20.7718C8.43834 20.9976 8.644 21.3945 8.77573 21.5703C9.23638 22.1852 9.92906 22.6015 10.7448 22.7538C11.0692 22.8144 11.7413 22.8144 12.0658 22.7538C13.0828 22.5639 13.8627 21.9964 14.2965 21.1306C14.5579 20.6089 14.6539 20.0367 14.6051 19.2914C14.5771 18.8638 14.4719 17.7814 14.3958 17.1387C14.3609 16.8444 14.357 16.7535 14.3786 16.7398C14.394 16.7301 14.4548 16.7219 14.5138 16.7217C14.7376 16.721 15.7842 16.6284 15.9378 16.5958C16.876 16.3965 17.6335 15.6247 17.8117 14.6864C17.8495 14.4876 17.9203 13.2844 17.9684 12.0229C17.9844 11.6058 17.9975 10.4612 17.998 9.45373L17.9988 7.63681L17.9371 7.50539C17.8228 7.26202 17.6035 7.07598 17.3522 7.00916C17.1839 6.96439 17.0787 6.97002 16.8284 7.03719C16.5269 7.11813 16.0817 7.13796 15.8084 7.08267C15.0317 6.92549 14.4478 6.39196 14.1984 5.61159C14.1133 5.34498 14.0928 4.92651 14.1509 4.63949C14.2615 4.09328 14.4873 3.75142 15.0731 3.2437C15.4161 2.94642 15.4843 2.51365 15.2492 2.12629C15.1536 1.96871 15.0432 1.87967 14.7908 1.75656C14.1964 1.46664 13.5506 1.30483 12.7147 1.23644C12.4155 1.21195 10.8845 1.18839 10.6405 1.20452ZM10.6289 2.94969C10.164 2.97582 9.78335 3.01512 9.58598 3.05731C9.11839 3.15732 8.57445 3.39551 8.19356 3.66708C7.90068 3.8759 7.44331 4.34302 7.25271 4.62798C6.94078 5.09434 6.72003 5.63839 6.62893 6.16521C6.48992 6.96925 6.50983 10.9446 6.66682 13.7296C6.70634 14.4305 6.72875 14.5239 6.89779 14.6927C7.06609 14.8608 7.16253 14.8926 7.61455 14.9291C10.0438 15.1255 12.7668 15.1255 15.196 14.9291C15.6481 14.8926 15.7445 14.8608 15.9128 14.6927C16.093 14.5127 16.1041 14.4568 16.1559 13.4622C16.2205 12.2221 16.2477 11.3688 16.2648 10.0418L16.2797 8.88241L16.1684 8.86718C16.1072 8.8588 16.0039 8.85176 15.9387 8.85155C15.6744 8.85065 15.1895 8.74384 14.8316 8.60765C13.6922 8.17407 12.7792 7.14784 12.4852 5.97035C12.3975 5.61914 12.373 5.3569 12.3857 4.90566C12.404 4.25525 12.5119 3.82722 12.7961 3.27835C12.8822 3.11212 12.9217 3.01331 12.9043 3.00757C12.7527 2.95744 11.1958 2.91784 10.6289 2.94969ZM10.1918 16.9528C10.1842 17.0229 10.1469 17.3523 10.1089 17.6849C9.94808 19.0898 9.90813 19.7566 9.9676 20.0428C10.046 20.4199 10.2936 20.7442 10.6212 20.8987C10.8926 21.0268 11.0497 21.0589 11.4053 21.0589C11.7609 21.0589 11.9179 21.0268 12.1894 20.8987C12.517 20.7442 12.7646 20.4199 12.843 20.0428C12.9025 19.7566 12.8625 19.0898 12.7017 17.6849C12.6637 17.3523 12.6264 17.0229 12.6188 16.9528L12.605 16.8255H11.4053H10.2055L10.1918 16.9528Z"
          fill="white"
        />
      </svg>
      <p class="item__nome">Palito Premiado</p>
    </div>
    <div class="menu__item" (click)="irParaExtrato()">
      <img class="item__icone" src="assets/images/icons/folha.png" />
      <p class="item__nome">Extrato</p>
    </div>
    <div class="menu__item" (click)="irParaMomentosEspeciais()">
      <img class="item__icone" src="assets/images/icons/claquete.png" />
      <p class="item__nome">Momentos especiais</p>
    </div>
    <div class="menu__item" (click)="irParaMissoes()">
      <img class="item__icone" src="assets/images/icons/bandeira.png" />
      <p class="item__nome">Missões</p>
    </div>
    <div class="menu__item" (click)="irParaBeneficios()">
      <img class="item__icone" src="assets/images/icons/star_menu.png" />
      <p class="item__nome">Benefícios</p>
    </div>
    <div class="menu__item" (click)="irParaCausa()">
      <img class="item__icone" src="assets/images/icons/causaMobile.png" />
      <p class="item__nome">Lovers pela causa</p>
    </div>
    <div class="menu__item" (click)="irParaNotificacoes()">
      <img class="item__icone" src="assets/images/icons/sino.png" />
      <p class="item__nome">Notificações</p>
      <div class="nova__notificacao" *ngIf="exibirNotificacao"></div>
    </div>
    <div class="menu__item" (click)="irParaoPrograma()">
      <img class="item__icone" src="assets/images/icons/programa.png" />
      <p class="item__nome">O Programa</p>
    </div>
    <div class="menu__item" (click)="irParaIndicacoes()">
      <img
        class="item__icone"
        src="assets/images/icons/pessoa-add-branco.png"
      />
      <p class="item__nome">Indicações</p>
    </div>
    <div class="menu__item" (click)="irParaAjuda()">
      <img
        class="item__icone"
        src="assets/images/icons/icone-branco-ajuda.png"
      />
      <p class="item__nome">Ajuda</p>
    </div>
    <div class="menu__item" (click)="exibirModalLogout(true)">
      <img class="item__icone" src="assets/images/icons/sair-branco.png" />
      <p class="item__nome">Sair</p>
    </div>
    <div class="footer__in__menu__navegacao" *ngIf="appOnly">
      <div class="barra"></div>
      <div class="menu__item" (click)="irPara('/cadastro_parceiros', false)">
        <p class="item__nome">Parceria Lovers</p>
      </div>
      <div class="menu__item" (click)="mostrarPopupTermos()">
        <p class="item__nome">Termos de Uso</p>
      </div>
      <div class="menu__item" (click)="mostrarPopupRegulamento()">
        <p class="item__nome">Regulamentos</p>
      </div>
      <div class="redes__sociais__app">
        <div class="rede__social">
          <a
            href="https://www.facebook.com/CacauShow"
            target="_blank"
            title="Facebook"
          >
            <i class="fa fa-facebook-f fa-2x"></i>
          </a>
        </div>
        <div class="rede__social">
          <a
            href="https://www.instagram.com/cacauloverscs"
            target="_blank"
            title="Instagram"
          >
            <i class="fa fa-instagram fa-2x"></i>
          </a>
        </div>
        <div class="rede__social">
          <a
            href="https://www.youtube.com/user/CacauShowBR"
            target="_blank"
            title="Youtube"
          >
            <i class="fa fa-youtube-play fa-2x"></i>
          </a>
        </div>
        <div class="rede__social">
          <a
            href="https://www.tiktok.com/@cacaushow?is_from_webapp=1&sender_device=pc"
            target="_blank"
            title="TikTok"
          >
            <img src="../../../../../assets/images/icons/tiktok.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="menu__item" (click)="irParaAprovacoes()">
    <img class="item__icone" src="assets/images/icons/aprovacoes.png" />
    <p class="item__nome">Aprovações</p>
  </div> -->
</div>

<div class="lovers__subheader" *ngIf="exibirSubheader">
  <div class="subheader__background">
    <!-- <img
      class="background__imagem"
      src="assets/images/backgrounds/background_topo.png"
    /> -->
  </div>
  <p class="subheader__titulo">{{ subheaderTitulo }}</p>
</div>

<app-voucher #voucherModal></app-voucher>
